import { render, staticRenderFns } from "./storeRanking.vue?vue&type=template&id=681987d4&scoped=true"
import script from "./storeRanking.vue?vue&type=script&lang=js"
export * from "./storeRanking.vue?vue&type=script&lang=js"
import style0 from "./storeRanking.vue?vue&type=style&index=0&id=681987d4&prod&lang=scss&scoped=true"
import style1 from "./storeRanking.vue?vue&type=style&index=1&id=681987d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681987d4",
  null
  
)

export default component.exports